import { getSourceName } from "@/modules/mine";
import type { Item } from "@/modules/mine/types";

export function formatBytes(value?: number) {
  if (!value || value <= 0) {
    return "Unknown";
  }

  const units = ["B", "KB", "MB", "GB"];
  let size = value;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  return `${size >= 10 || unitIndex === 0 ? size.toFixed(0) : size.toFixed(1)} ${units[unitIndex]}`;
}

export function formatDate(value?: string) {
  if (!value) {
    return "Unknown";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat("zh-CN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
}

export function formatPercent(value?: number) {
  if (typeof value !== "number") {
    return "Unknown";
  }

  return `${Math.round(value * 100)}%`;
}

export function getImageTitle(item: Item) {
  return item?.title || "Untitled image";
}

export function getImageSourceName(item: Item) {
  return item?.url ? getSourceName(item.url) : "Image";
}

export function getImageExtension(item: Item) {
  return (
    item?.mime_type?.split("/").at(1) ||
    "image"
  ).toUpperCase();
}

export function getImageSizeText(item: Item) {
  if (!item.image?.width || !item.image?.height) {
    return "Unknown size";
  }

  return `${item.image.width} × ${item.image.height}`;
}

export function getOrientationLabel(item: Item) {
  switch (item.image?.orientation) {
    case "landscape":
      return "横图";
    case "portrait":
      return "竖图";
    case "square":
      return "方图";
    default:
      return "Unknown";
  }
}

export function getPreviewTitle(item: Item, sourceName: string) {
  if (item.format === "image") {
    return getImageTitle(item);
  }

  if (item.format === "website") {
    return item?.title || sourceName;
  }

  if (item.format === "text") {
    return item?.title || "Text note";
  }

  return "Untitled";
}
